import React, { useContext } from "react";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import toSeoUrl from "@functions/toSeoUrl";
import { UserContext } from "@context/UserContext";
import V3SessionButton from "@components/V3/V3SessionButton";
import { getSessionType } from "@utils/ticketUtils";

const PrimarySessions = ({ groupedSessions = [], selection = {} }) => {
    const { promoDetails } = useContext(UserContext);
    const promoTicketClasses = promoDetails?.promoTicketClasses || [];

    if (Object.keys(groupedSessions).length < 1) {
        return (
            <div className="sessions-available__message">
                <p className="sessions-available__message-title">
                    Sorry, we couldn&apos;t find any results for your chosen cinema
                </p>
                <p className="sessions-available__message-text">
                    Please select from one of the nearby sessions below, or select a different date
                </p>
            </div>
        );
    }

    const formattedDate = selection?.date ? format(new Date(selection.date), "EEE d MMM") : "";

    return (
        <div className="sessions-available">
            {Object.entries(groupedSessions).map(([cinema, sessions]) => {
                const first = sessions[0];

                const venueName = first.venue_name || "Unknown venue";
                const venueId = first.venue_id;
                const rawDistance = Number(first.venue_distance);
                const distance = Number.isFinite(rawDistance) ? rawDistance.toFixed(1) : "?";

                return (
                    <div key={`${venueId}-${first.movie_id}-${first.venue_id}`} className="sessions-available__venue-group">
                        <Link
                            className="sessions-available__venue-title"
                            to={`/venue/${venueId}/${toSeoUrl(venueName)}`}
                        >
                            {venueName} - {distance} km
                        </Link>
                        <div className="sessions-available__date-title">{formattedDate}</div>
                        <div className="sessions-available__list">
                            {sessions.map((session) => {
                                const experience_type = getSessionType(session);
                                const showPromoIcon = promoTicketClasses.includes(Number(session?.ticket_class_id));
                                return (
                                    <V3SessionButton
                                        key={session.id}
                                        session={{ ...session, experience_type }}
                                        showPromoIcon={showPromoIcon}
                                    />
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default PrimarySessions;
